module.exports = __webpack_public_path__ + "static/media/slidePicture4.406080cd.jpg";